// extracted by css-extract-rspack-plugin
export default {"controls":"src-pages-projects-hub-OrderedListControls-module__controls-gyJqrY","arrowBtn":"src-pages-projects-hub-OrderedListControls-module__arrowBtn-CfuT9e","alphabetizeBtn":"src-pages-projects-hub-OrderedListControls-module__alphabetizeBtn-vQIcpt"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"controls\":\"src-pages-projects-hub-OrderedListControls-module__controls-gyJqrY\",\"arrowBtn\":\"src-pages-projects-hub-OrderedListControls-module__arrowBtn-CfuT9e\",\"alphabetizeBtn\":\"src-pages-projects-hub-OrderedListControls-module__alphabetizeBtn-vQIcpt\"}";
        // 1788963438885
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  